module.exports = __webpack_public_path__ + "img/personal-center-hover.b93f9ce.png";